<template>
  <nav class="k-navbar" :class="{'whiteNav': whiteNav}">
    <div class="navbar-container container">
      <ul class="menu-wrapper link-wrapper">
        <li>
          <a class="brand-logo" href="/"></a>
        </li>
      </ul>
      <ul class="menu-wrapper right-drawer-full">
        <li>
          <div class="dropdown-container">
            <a href="#">关于和鲸</a>
            <div class="dropdown-list-container">
              <div class="dropdown-mask"></div>
              <ul class="dropdown-list">
                <li @click="$router.push({name: 'about'})" >关于和鲸</li>
                <li @click="$router.push({name: 'product'})">产品与服务</li>
                <li @click="$router.push({name: 'partner'})">客户案例</li>
              </ul>
            </div>
          </div>
        </li>
        <li>
          <div class="dropdown-container">
            <a @click="navToKesci"><img src="../assets/kesci.svg"><span class="parting-line">|</span><span>数据科学社区</span></a>
          </div>
        </li>
        <li>
          <div class="dropdown-container">
            <a href="#"><img src="../assets/kescilab.svg"><span class="parting-line">|</span><span>数据科学平台 </span></a>
            <div class="dropdown-list-container">
              <div class="dropdown-mask"></div>
              <ul class="dropdown-list">
                <li @click="$router.push({name: 'K-Lab'})">K-Lab介绍</li>
                <li @click="$router.push({name: 'K-Lab-edu'})">K-Lab教育版</li>
              </ul>
            </div>
          </div>
        </li>
        <li>
          <router-link class="link" :to="{name: 'contact'}">联系方式</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
export default {
  methods: {
    navToKesci() {
      window.open(`https://www.kesci.com`, '_blank');
    }
  },
  computed: {
    whiteNav() {
      return this.$route.name !== 'home';
    }
  }
};
</script>

<style lang="scss">
@import '../styles/variables.scss';
$nav-height: 64px;
// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity .5s
// }

// .fade-enter,
// .fade-leave-to {
//   opacity: 0
// }

nav.k-navbar {
  z-index: 100;
  position: absolute;
  min-width: 1200px;
  width: 100%;
  top: 0;
  left: 0;
  .navbar-container.container {
    // padding: 0 5px;
    max-width: 1170px;
    display: flex;
    .menu-wrapper {
      display: flex;
      list-style: none;
      font-size: 16px;
      margin: 0;
      padding: 0;
      >li {
        color: #ffffff;
        height: $nav-height;
        font-size: 14px;
        margin-right: 40px;
        flex-grow: 0;
        flex-shrink: 0;
        &:last-child {
          margin-right: 0px;
        }
        a {
          cursor: pointer;
          text-align: center;
          display: flex;
          align-items: center;
          min-width: 75px;
          height: $nav-height;
          line-height: $nav-height;
          color: #fff;
          transition: color ease $transition-time, border-color ease $transition-time;
          .parting-line {
            margin: 0px 8px;
          }
          &.brand-logo {
            width: 64px;
            //margin-right: 0;
            background-image: url("../assets/logo.png");
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
          }
        }
      }
    }
    .link-wrapper {
      flex-grow: 1
    }
    .menu-wrapper.right-drawer-lite {
      position: relative;
      display: none;
      .iconfont {
        font-size: 14px;
      }
      .k-dropdown-content {
        padding: 4px 0;
        border-radius: 2px;
        right: 0;
        height: auto;
        display: block;
        position: absolute;
        background: rgba(210, 210, 210, 0.4);
        top: 39px;
        >a {
          height: 24px;
          line-height: 24px;
          display: block;
          width: 5em;
          text-align: center;
        }
      }
    }
  }
  .dropdown-container {
    position: relative;
    .dropdown-list-container {
      display: none;
      position: absolute;
      margin: auto;
      width: 100%;
      min-width: 180px;
      left: calc(50% - 90px);
      border: solid 1px;
      border-image: linear-gradient(to right, #0446a1, #0091a3) 30 30;
      ul.dropdown-list {
        list-style: none;
        background: rgba(9, 40, 70, 0.9);
        border-radius: 2px;
        padding: 0px;
        li {
          cursor: pointer;
          text-align: center;
          padding: 12px 24px;
          border-left: solid 4px transparent;
          &:hover {
            border-color: #026EFF;
            background: rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
    &:hover {
      .dropdown-list-container {
        display: block;
      }
    }
  }
  &.whiteNav {
    .dropdown-container {
      border: none;
      color: #333;
      ul.dropdown-list {
        background: rgba(255, 255, 255, 0.8);
        li:hover {
          background: rgba(2, 110, 255, 0.1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue